import classnames from 'classnames';
import { Trans } from 'react-i18next';

type Props = {
  onSelect: () => void;
  value: string;
  maxParticipants?: number | null;
  numOfConfirmedParticipants?: number;
  isSelected?: boolean;
};

export function BookitoTimeSlotChip({
  onSelect,
  isSelected,
  maxParticipants,
  numOfConfirmedParticipants,
  value,
}: Props) {
  return (
    <div className="my-2 flex flex-col items-center text-center">
      <button
        className={classnames(
          'border-2 w-full rounded-full  border-primary-default pt-1 pb-2 px-1 sm:px-2 text-sm',
          isSelected ? 'bg-primary-default text-primary-contrast' : 'bg-white'
        )}
        type="button"
        onClick={onSelect}
      >
        {value}
      </button>
      {maxParticipants ? (
        <div className="relative -top-[15%] bg-gray-800 rounded-md text-[8px] text-white w-fit px-1 py-0.5 text-center">
          {
            <>
              {maxParticipants - (numOfConfirmedParticipants || 0)} / {maxParticipants}{' '}
              <Trans i18nKey="free"></Trans>
            </>
          }
        </div>
      ) : null}
    </div>
  );
}
